<div class="page-header">
  <app-prev-next-button (click)="toSetup()" direction="left" label="setup"></app-prev-next-button>
  <h1>Setup de Setores</h1>
  <button mat-raised-button class="primary" (click)="finish()">
    Ir para próximo passo
  </button>
</div>

<div class="page-content">
  <div class="left-panel">
    <div class="buttons">
      <button mat-raised-button (click)="changeView('SECTORS')" [class.active]="selectedView === 'SECTORS'">Setores</button>
      <button mat-raised-button (click)="changeView('PIGEONHOLES')" [class.active]="selectedView === 'PIGEONHOLES'">Escaninho</button>
    </div>

    <div class="left-side sectors" *ngIf="showSectorsList">
      <button mat-raised-button class="add-group" (click)="openModal()" *ngIf="canManageGroups && state !== 'ADDING_TAGS'"
        [disabled]="selectedView !== 'PIGEONHOLES' ? !canClickButton(actionsEnum.ADD_GROUND_GROUP, userRole) : !canClickButton(actionsEnum.ADD_PIGEONHOLE_GROUP, userRole)">
        adicionar setor
      </button>
      <button mat-raised-button class="remove-group" (click)="removeSector()" *ngIf="canManageGroups && state === 'ADDING_TAGS'"
        [disabled]="selectedView !== 'PIGEONHOLES' ? !canClickButton(actionsEnum.REMOVE_GROUND_GROUP, userRole) : !canClickButton(actionsEnum.REMOVE_PIGEONHOLE_GROUP, userRole)">
        remover setor
      </button>
      <button mat-raised-button class="save-group" (click)="handleSaveAction()" *ngIf="state === 'ADDING_TAGS'"
        [disabled]=" isSavingPigeonholeAssignments || (selectedView !== 'PIGEONHOLES' ? !canClickButton(actionsEnum.SET_TAGS_GROUND_GROUP, userRole) : !canClickButton(actionsEnum.SET_PIGEONHOLE_GROUP, userRole))">
        salvar
      </button>
      <app-ground-groups-list
        [groups]="displayedGroups"
        [state]="state"
        [selectedGroupId]="currentGroundGroupId"
        (onGroupClick)="groupClicked($event)"
        (onGroupHighLight)="groupHighLighted($event)"
      >
      </app-ground-groups-list>
    </div>
    <div class="left-side pigeonholes" *ngIf="showPigeonholeList">
      <app-setup-ground-pigeonhole-positions-list
        [positions]="pigeonholePositions"
        [loading]="isPigeonholeListLoading"
        (positionClick)="handlePigeonholeListPositionClick($event)"
        (goBack)="handlePigeonholeListGoBack()"
      >
      </app-setup-ground-pigeonhole-positions-list>
    </div>
  </div>

  <div class="right-side">
    <ng-container *ngIf="!showPigeonholeMap; else pigeonholeMapOverlay">
      <app-side-color-card color="primary-1">
        <app-ground-groups-map
          id="zz"
          (positionClicked)="positionSelected($event)"
          (pigeonholeClicked)="handlePigeonholeClicked($event)"
          [state]="state"
          [selectedPositionIds]="selectedPositionIds"
          [selectedGroupId]="currentGroundGroupId"
          [map]="map"
          content
          #mapComponent>
        </app-ground-groups-map>
      </app-side-color-card>
    </ng-container>
    <ng-template #pigeonholeMapOverlay>
      <app-side-color-card color="primary-1">
        <app-setup-ground-pigeonhole-map
          id="zz"
          class="pigeonhole-map-view"
          [map]="selectedPigeonholeMap"
          [selectionMode]="canSelectPigeonholeInternalPositions"
          [selectedPositionIds]="pigeonholePositionsIds"
          [mapMode]="'pigeonhole'"
          (positionClicked)="handlePigeonholeMapPositionClick($event)"
          (mapLoaded)="onPigeonholeMapLoaded()"
          content
          #mapComponent>
        </app-setup-ground-pigeonhole-map>
      </app-side-color-card>
    </ng-template>
  </div>
</div>
